import { render } from "./Searchbox.vue?vue&type=template&id=407c9daf&scoped=true"
import script from "./Searchbox.vue?vue&type=script&lang=js"
export * from "./Searchbox.vue?vue&type=script&lang=js"

import "./Searchbox.vue?vue&type=style&index=0&id=407c9daf&lang=scss&scoped=true"

import exportComponent from "/Users/parasagrawal/projects/twitter-helpdesk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407c9daf"]])

export default __exports__